var render = function render(){var _vm=this,_c=_vm._self._c;return _c('task-page',{attrs:{"resource":_vm.taskResource,"archivedResource":_vm.archivedResource,"obj-id":_vm.resId,"list-id":_vm.id || 'TaskListForCustomResourceSidePage',"getParams":_vm.getParams,"isSidepage":"","ignoreResId":_vm.ignoreResId,"root":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }